import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Add, ArrowBack, Done, Edit } from "@mui/icons-material";
import { ACTUALIZAR_ETIQUETA, CREAR_ETIQUETA } from "../graphql/mutations";
import { useMutation } from "@apollo/client";
import { MainContext } from "../../../../../Context/MainCtx";
import { CircularProgress, Stack } from "@mui/material";

export default function NuevaEtiqueta({
  edit,
  data,
  refetch,
  external = false,
  refetchExternal = null,
}) {
  const [open, setOpen] = React.useState(false);
  const [etiqueta, setEtiqueta] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const { snackMessage, tokenDecoded } = React.useContext(MainContext);
  const [crearEtiqueta] = useMutation(CREAR_ETIQUETA);
  const [actualizarEtiqueta] = useMutation(ACTUALIZAR_ETIQUETA);

  const handleOpen = () => {
    setOpen(true);
    if (edit) setEtiqueta(data.etiqueta);
  };
  const handleClose = () => {
    setOpen(false);
    setEtiqueta("");
  };

  const handleSaveEtiqueta = async (e) => {
    try {
      e.stopPropagation();
      e.preventDefault();
      if (!etiqueta) return;
      setLoading(true);
      if (!edit) {
        //si es nuevo
        const res = await crearEtiqueta({
          variables: {
            idEmpresa: tokenDecoded ? tokenDecoded.idEmpresa : "",
            etiqueta,
          },
        });
        snackMessage({
          message: res.data.crearEtiqueta.message,
          variant: "success",
        });
      } else {
        //si va a actualizar
        const res = await actualizarEtiqueta({
          variables: {
            idEtiqueta: data._id,
            idEmpresa: tokenDecoded ? tokenDecoded.idEmpresa : "",
            etiqueta,
          },
        });
        snackMessage({
          message: res.data.actualizarEtiqueta.message,
          variant: "success",
        });
      }
      if (external && refetchExternal) refetchExternal();
      if (refetch) refetch();
      setLoading(false);
      handleClose();
    } catch (err) {
      setLoading(false);
      snackMessage({
        message: err.message ? err.message : "Error Desconocido",
        variant: "error",
      });
    }
  };

  return (
    <div>
      {edit ? (
        <IconButton onClick={handleOpen}>
          {loading ? <CircularProgress size={20} color="inherit" /> : <Edit />}
        </IconButton>
      ) : external ? (
        <IconButton onClick={handleOpen} size="small" color="primary">
          <Add />
        </IconButton>
      ) : (
        <Button
          onClick={handleOpen}
          color="primary"
          size="small"
          disableElevation
          sx={{ textTransform: "none" }}
          variant="contained"
          startIcon={<Add />}
        >
          Nuevo
        </Button>
      )}

      <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
        ModalProps={{
          componentsProps: {
            backdrop: {
              sx: { background: "none" },
            },
          },
        }}
        PaperProps={{
          elevation: 1,
          sx: { width: { xs: "100vw", sm: "40vw" } },
        }}
      >
        <Toolbar variant="dense" />
        <DialogTitle component="div">
          <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
            <IconButton onClick={() => handleClose()}>
              <ArrowBack />
            </IconButton>
            <Typography variant="h6" color="GrayText">
              {edit ? `Editar etiqueta` : "Nueva etiqueta"}
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            <Button
              startIcon={
                loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <Done />
                )
              }
              variant="contained"
              size="small"
              sx={{textTransform: "none"}}
              disableElevation
              type="submit"
              form="formEtiqueta"
            >
              Guardar
            </Button>
          </Stack>
        </DialogTitle>
        <DialogContent sx={{ py: 0 }}>
          <form id="formEtiqueta" onSubmit={handleSaveEtiqueta}>
            <TextField
              label="Nombre etiqueta"
              size="small"
              variant="outlined"
              margin="dense"
              fullWidth
              onChange={(e) => setEtiqueta(e.target.value)}
              value={etiqueta}
              required
            />
          </form>
        </DialogContent>
      </Drawer>
    </div>
  );
}
